/**
 * @return {boolean}
 */
export function isDevMode() {
  return false
}
